import TeacherAssignmentByLocationReport from "@/pages/reports/print/teacher-assignment-by-location";
import { createFileRoute } from "@tanstack/react-router";

interface SearchParams {
  centerId: string;
}

export const Route = createFileRoute(
  "/_authenticated/reports/detailed-view/teacher-assignment-by-location/$centerId",
)({
  validateSearch: (search): SearchParams => {
    return {
      centerId: search.centerId as string,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <TeacherAssignmentByLocationReport />;
}
